import actions from './actions';

const {
  GET_DATA_VEHICLE,
  SET_DATA_VEHICLE,
  DELETE_DATA_VEHICLE,
  EDIT_DATA_VEHICLE,
  GET_DATA_BEGIN,
  GET_DATA_FINISH,
  SET_NEW_DATA_VEHICLE,
} = actions;

const initialState = {
  data: [],
  total: 0,
  loading: false,
};

const vehiclesReducer = (state = initialState, action: any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_VEHICLE:
      return { ...state };
    case SET_DATA_VEHICLE:
      return {
        ...state,
        data: data.results,
        total: data.results.length,
        loading: false,
      };
    case DELETE_DATA_VEHICLE:
      return {
        ...state,
        data: state.data.filter((vehicle: any) => vehicle.id !== data.id),
      };
    case EDIT_DATA_VEHICLE: {
      const index = state.data.findIndex((vehicle: any) => vehicle.id === data.id);
      // Merge, no reemplazo: conserva estadoEfectivo si la respuesta no lo
      // trae (evita el flash "Disponible" en vehículos en uso al editar).
      if (index !== -1) {
        const newArray: any = [...state.data];
        newArray[index] = { ...(state.data[index] as any), ...data };
        return { ...state, data: newArray };
      }
      return { ...state, data: [...state.data, data] };
    }
    case SET_NEW_DATA_VEHICLE:
      return { ...state, data: [data, ...state.data] };
    case GET_DATA_BEGIN:
      return { ...state, loading: true };
    case GET_DATA_FINISH:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export { vehiclesReducer };
